import Cargando from 'components/Varios/Cargando'
import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react'
import { Row, Col, Button, Input } from "reactstrap"
import TableActividadesHorasExtras from './TableActividadesHorasExtras'
import { DetalleActividadHorasExtras, DetalleGrupoActividades, DetalleParametrosActividadesHE, PostActividadHoraExtra, PostGrupoActividadesHorasExtras } from '../TypesParametrosHorasExtras'
import SelectItem2 from 'components/Varios/SelectNew'
import { ConsultarDetalleGrupoActividades, ConsultarInformacionGeneralParametrosActividades, CrearActividadHoraExtra, CrearGrupoActividadHoraExtra } from '../FunctionsParametrosHE'
import { alertService } from 'components/Varios/alert_service'
import Swal from 'sweetalert2'

//SVG
import ExitoSVG from "../../../../../assets/icons/HorasExtras/Exitosa.svg"
import WarningSVG from "../../../../../assets/icons/HorasExtras/Error.svg"
import AnuncioSVG from "../../../../../assets/icons/Permisos/Anuncio.svg"



import ModalCargando from 'components/Varios/ModalCargando'
import CreateSelect from 'components/Varios/SelectsComponent/CreateSelect'
import { SelectCombo } from 'components/Types/GeneralTypes'
import { useParametrosHorasExtrasContext } from 'Context/ParametrosHorasExtrasContext'
import { RegimenLaboralHEDTO } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE'

export function showAlert(message:string, isSuccess:boolean,imageSrc:string="") {
    
    var finalImage = imageSrc;

    if(finalImage === ""){
        finalImage = isSuccess ? ExitoSVG : WarningSVG
    }
    
    
    Swal.fire({
        text: message,
        imageUrl: finalImage,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error", 
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertHTML(content:string, isSuccess:boolean,imageSrc:string="") {
    
    var finalImage = imageSrc;

    if(finalImage === ""){
        finalImage = isSuccess ? ExitoSVG : WarningSVG
    }
    
    
    Swal.fire({
        text: "",
        html:content,
        imageUrl: finalImage,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error", 
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertAviso(message:string,) {
    
    
    
    Swal.fire({
        
        html:message,
        imageUrl: AnuncioSVG,
        imageHeight: 100,
        imageAlt: "Anuncio", 
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}


export default function ActividadesHorasExtras() {

    const [loading, setloading] = useState<boolean>(false)
    const [creando, setcreando] = useState<boolean>(false)

    const [creandoGrupoActividad, setcreandoGrupoActividad] = useState<boolean>(false)

    const [textoActividad, settextoActividad] = useState<string>("")
    const [regimenLaboralSeleccionado, setRegimenLaboralSeleccionado] = useState<number >(0);
    const [opcionRegimenLaboralSeleccionada, setopcionRegimenLaboralSeleccionada] = useState<SelectCombo|undefined >(undefined);

    const [informacionGeneralActividadesHE, setinformacionGeneralActividadesHE] = useState<DetalleParametrosActividadesHE | undefined>(undefined)

    const [opcionSeleccionada, setopcionSeleccionada] = useState<SelectCombo|undefined>(undefined)


    const {
        recargarGruposActivos,
        setrecargarGruposActivos,
        recargarInformacionGeneralGrupos,
        setrecargarInformacionGeneralGrupos
        
    } = useParametrosHorasExtrasContext()

    function VaciarCampos(){
        settextoActividad("")
        setRegimenLaboralSeleccionado(0)
        setopcionSeleccionada(undefined)

    }


    
    

    async function ObtenerInformacionGeneral() {
        setloading(true)

        const respuesta = await ConsultarInformacionGeneralParametrosActividades();

        if (respuesta.status === 200 && respuesta.dataResponse && respuesta.dataResponse.listadoDetalleRegimen) {
            setinformacionGeneralActividadesHE(respuesta.dataResponse);
        }
        else if(respuesta.status === 401){
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        else {
            alertService.error(respuesta.errorMessage)
        }
        
        setloading(false)
    }


    const ConsultarGrupoActividades =  useCallback(
      async () => {
        const respuesta = await ConsultarDetalleGrupoActividades();

        if(respuesta.status === 200 && respuesta.dataResponse){
            setinformacionGeneralActividadesHE((prev) => {
                if(prev && respuesta.dataResponse){
                    return {...prev,listadoGrupoActividades:respuesta.dataResponse}
                }
                return prev
            })
            if(!recargarGruposActivos) {
                setrecargarInformacionGeneralGrupos(true)
            }
            

        }
        else if(respuesta.status === 401){
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        else {
            showAlert("Ha ocurrido un inconveniente al consultar grupos de actividades",false);
        }

        setrecargarGruposActivos(false)
      },
      [recargarGruposActivos],
    )
    

    // async function ConsultarGrupoActividades() 
    // {
    //     const respuesta = await ConsultarDetalleGrupoActividades();

    //     if(respuesta.status === 200 && respuesta.dataResponse){
    //         setinformacionGeneralActividadesHE((prev) => {
    //             if(prev && respuesta.dataResponse){
    //                 return {...prev,listadoGrupoActividades:respuesta.dataResponse}
    //             }
    //             return prev
    //         })
    //         setrecargarInformacionGeneralGrupos(true)

    //     }
    //     else {
    //         showAlert("Ha ocurrido un inconveniente al consultar grupos de actividades",false);
    //     }

    //     setrecargarGruposActivos(false)
    // }

    async function CrearActividad(actividad:PostActividadHoraExtra){
        setcreando(true)

        const respuesta = await CrearActividadHoraExtra(actividad);

        if(respuesta.status === 200){
            showAlert("La actividad ha sido agregada con éxito",true);
            VaciarCampos()
            await ObtenerInformacionGeneral()
        }
        else if(respuesta.status === 401){
            showAlert("Su usuario no se encuentra autorizado para realizar la acción", false)
        }
        else {
            showAlert(respuesta.errorMessage??"Ha ocurrido un inconveniente",false);
        }


        setcreando(false)
    }

    async function CrearGrupoActividad(newOption:SelectCombo) {
        setcreandoGrupoActividad(true)

        const nuevoGrupo:PostGrupoActividadesHorasExtras = {
            grupo:newOption.value
        }
        
        const respuesta =await CrearGrupoActividadHoraExtra(nuevoGrupo)

        if(respuesta.status === 200){
            showAlert("Se ha creado el grupo con éxito",true);
            await ConsultarGrupoActividades();
        }
        else if(respuesta.status === 401){
            showAlert("Su usuario no se encuentra autorizado para realizar la acción", false)
        }
        else{
            const mensajeDefault = "Ha ocurrido un inconveniente al tratar de crear el grupo"
            showAlert(respuesta.errorMessage??mensajeDefault,false);
        }




        setcreandoGrupoActividad(false)
    }

    function ObtenerOpcionesGrupos(listadoGruposActividades:DetalleGrupoActividades[]|undefined){
        
        if(listadoGruposActividades) {
            const listadoMapeado:SelectCombo[] = listadoGruposActividades.map((v,i) => {
                return {
                    label:v.nombreGrupo,
                    value:v.idGrupo.toString()
                }
            })
    
            return listadoMapeado
        }

        return []
        

    }

    useEffect(() => {
        ObtenerInformacionGeneral()
    }, [])

    useEffect(() => {
        if(recargarGruposActivos){
            ConsultarGrupoActividades()
        }
    }, [recargarGruposActivos])
    


    const handleChangeSelect = (setter: Dispatch<SetStateAction<number>>) => (value: string) => {
        setter(Number(value)); 
    };

    const opcionesGrupo:SelectCombo[] = ObtenerOpcionesGrupos(informacionGeneralActividadesHE?.listadoGrupoActividades);
    
    const OpcionesRegimen = (detalleRegimen:RegimenLaboralHEDTO[]) => {
        const opciones = detalleRegimen.map((reg,i) => {
            return ({ value: reg.idRegimenLaboral.toString(), label: reg.siglasRegimenLaboral.toString() })
        })

        return opciones;     
    }

    
    useEffect(() => {
      if(informacionGeneralActividadesHE && informacionGeneralActividadesHE.listadoDetalleRegimen.length > 0){

        const opciones:SelectCombo[] = OpcionesRegimen(informacionGeneralActividadesHE.listadoDetalleRegimen)

        const opcionElegida = opciones.find((v) => v.value === regimenLaboralSeleccionado.toString())
        if(opcionElegida){
            setopcionRegimenLaboralSeleccionada(opcionElegida)
        }
        else{
            setopcionRegimenLaboralSeleccionada(undefined)
        }


        
      }
    }, [regimenLaboralSeleccionado,informacionGeneralActividadesHE?.listadoDetalleRegimen])
    


    // useEffect(() => {
    //   if(informacionGeneralActividadesHE?.listadoActividades && informacionGeneralActividadesHE.listadoActividades.length > 0){
    //     const primeraOpcion:SelectCombo = {
    //         label : informacionGeneralActividadesHE.listadoGrupoActividades[0].nombreGrupo,
    //         value: informacionGeneralActividadesHE.listadoGrupoActividades[0].idGrupo.toString()
    //     }
    //     setopcionSeleccionada(primeraOpcion);
    //   }
    // }, [informacionGeneralActividadesHE?.listadoActividades])
    

    // <Row>
    // <Col className="pr-1" md="2">
    //     <FormGroup>
    //         <Label for="regimenLaboral">Régimen Laboral*</Label>
    //         <SelectItem2
    //             options={regimenLaborales.map(reg => ({ value: reg.idRegimenLaboral.toString(), label: reg.siglasRegimenLaboral.toString() }))}
    //             placeholder=""
    //             name="regimenLaboral"
    //             id="regimenLaboral"
    //             icon="fa-caret-down"
    //             value={regimenLaboralSeleccionado}
    //             onChange={handleChangeSelect(setRegimenLaboralSeleccionado)}

    //         />
    //     </FormGroup>
    // </Col>

    return (
        <React.Fragment>
            {loading && <Cargando />}
            {!loading && (
                <Row className="row-no-margin">
                    <Col xl={12}>
                        <Row >
                            
                            
                            <Col xl={3}>
                                    <Row>
                                        <Col xl={12}>
                                        <span className={"labelParametrosHE"}> Grupo</span>
                                        </Col>
                                    </Row>
                                    {
                                        creandoGrupoActividad ?
                                        <Cargando/>
                                        :
                                        <CreateSelect
                                            value={opcionSeleccionada}
                                            opciones={opcionesGrupo}
                                            icon="fa-caret-down"
                                            placeholder='Seleccione...'
                                            onChange={(valor) => setopcionSeleccionada(valor)}
                                            onCreate={(valorNuevo:SelectCombo) => CrearGrupoActividad(valorNuevo) }
                                        />
                                    }
                            </Col>
                            <Col xl={3}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelParametrosHE"}> Régimen</span>

                                    </Col>
                                    {
                                        informacionGeneralActividadesHE !== undefined && informacionGeneralActividadesHE.listadoDetalleRegimen.length > 0 && (
                                            <Col xl={12}>
                                                <SelectItem2
                                                    options={informacionGeneralActividadesHE.listadoDetalleRegimen.map(reg => ({ value: reg.idRegimenLaboral.toString(), label: reg.siglasRegimenLaboral.toString() }))}
                                                    placeholder=""
                                                    name="regimenLaboral"
                                                    id="regimenLaboral"
                                                    icon="fa-caret-down"
                                                    value={regimenLaboralSeleccionado}
                                                    onChange={handleChangeSelect(setRegimenLaboralSeleccionado)}

                                                />
                                            </Col>


                                        )
                                    }


                                </Row>
                            </Col>

                            <Col xl={4}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelParametrosHE"}> Actividad</span>

                                    </Col>
                                    <Col xl={12}>
                                        <Input type="text" value={textoActividad} onChange = {(e) => {
                                            var texto = e.target.value;
                                            if(texto){
                                                texto = texto.toUpperCase()
                                            }
                                            settextoActividad(texto)}
                                            
                                        }
                                            maxLength = {200}
                                        >
                                        </Input>
                                    </Col>

                                </Row>

                            </Col>
                           
                            <Col xl={1} className={"d-flex justify-content-start"}>
                                <Button 
                                    className={"buttonAgregarActividades"} 
                                    disabled = {textoActividad === "" || regimenLaboralSeleccionado === 0 || opcionSeleccionada === undefined} 
                                    onClick = { () => CrearActividad({
                                        actividad: textoActividad,
                                        regimen: regimenLaboralSeleccionado,
                                        grupo : opcionSeleccionada === undefined ? 0 : +opcionSeleccionada.value 
                                    })}
                                    >
                                        Agregar
                                </Button>
                            </Col>
                            <Col xl={1} className={"d-flex justify-content-start"}>
                                <Button 
                                    
                                    className={"buttonLimpiarCampos"} 
                                    onClick = { () => VaciarCampos()  }>
                                        Limpiar
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={12}>
                        {
                            informacionGeneralActividadesHE !== undefined && informacionGeneralActividadesHE.listadoActividades.length > 0 &&
                            (
                                <TableActividadesHorasExtras
                                    actividadesHorasExtras={informacionGeneralActividadesHE.listadoActividades}
                                    opcionesEstado = {informacionGeneralActividadesHE.opcionesEstadoActividad}
                                    cargarActividades={()=> ObtenerInformacionGeneral()}
                                    opcionesGrupo={opcionesGrupo}
                                    grupoFiltro={opcionSeleccionada ? opcionSeleccionada.label : ""}
                                    regimenFiltro={opcionRegimenLaboralSeleccionada ? opcionRegimenLaboralSeleccionada.label : "" }
                                />

                            )

                        }

                    </Col>

                </Row>


            )}
            <ModalCargando
                show = {creando}
                onClose={() => setcreando(false)} 
                size='xl'
                textoCargando='Creando Actividad' 
            />
        </React.Fragment>
    )
}
